<template>
  <div class="wrap">
    <Loader class="loader" v-if="availableDatesLoading" />
    <vc-date-picker
      v-if="isRangeMode"
      v-model="computeRange"
      is-range
      :select-attribute="rangeDateAttr"
      :drag-attribute="rangeDateAttr"
      class="calendar-wrapper"
      :class="[display.smAndDown || '--disabled-header']"
      @dayclick="(day) => day.el.blur()"
      :available-dates="formatedAvailableDates"
      @update:to-page="(v) => $emit('to-page', v)"
    />
    <vc-calendar
      v-else
      :value="value"
      :attributes="attributes"
      @dayclick="onDayClick"
      class="calendar-wrapper"
      :class="[display.smAndDown || '--disabled-header']"
      :available-dates="formatedAvailableDates"
      @update:to-page="(v) => $emit('to-page', v)"
    />
  </div>
</template>
<script>
import { parseISO, toDate, format } from 'date-fns'
import { ref } from '@vue/composition-api'

import Loader from '@/components/loader'
import { highlightStyle, highlightContentStyle } from './style'
import { useDisplay } from '@/hooks'
import { mapGetters } from 'vuex'

export default {
  name: 'filter-calendar',
  components: { Loader },
  props: {
    value: {
      type: Array
    },
    rangeValue: {
      start: String,
      end: String
    },
    mode: {
      type: String,
      default: ''
    },
    availableDates: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    ...mapGetters('timeslots', ['availableDatesLoading']),
    computeRange: {
      get() {
        return {
          start: toDate(parseISO(this.rangeValue.start)),
          end: toDate(parseISO(this.rangeValue.end))
        }
      },
      set(v) {
        const _f = (val) => format(val, 'yyyy-MM-dd')
        const start = v === null ? null : _f(v.start)
        const end = v === null ? null : _f(v.end)

        this.$emit('onRangeValue', { start, end })
      }
    },
    formatedAvailableDates() {
      if (!this.availableDates.length) return
      return { days: this.availableDates.map((v) => Number(v.split('-')[2])) }
    },
    isRangeMode() {
      return this.mode === 'range'
    },
    attributes() {
      const attr = this.value.map((date) => ({
        highlight: {
          style: highlightStyle,
          contentStyle: highlightContentStyle
        },
        class: 'is-disabled',
        dates: toDate(parseISO(date))
      }))

      const isNow = this.value.find(
        (el) => el === format(new Date(), 'yyyy-MM-dd')
      )

      if (!isNow) {
        attr.push({
          key: 'today',
          highlight: {
            style: {
              background: `white`,
              border: `2px solid #27926D`
            },
            contentStyle: {
              color: '#27926D',
              fontFamily: 'Effra-Medium'
            }
          },
          dates: new Date()
        })
      }

      return attr
    }
  },
  setup() {
    const calendarRef = ref(null)
    const display = useDisplay()

    const rangeDateAttr = {
      highlight: {
        start: {
          style: highlightStyle,
          contentStyle: highlightContentStyle
        },
        base: {
          style: {
            backgroundColor: '#EEF8F0'
          }
        },
        end: {
          style: highlightStyle,
          contentStyle: highlightContentStyle
        }
      }
    }

    function onDayClick(day) {
      const formatDay = format(day.date, 'yyyy-MM-dd')
      const sameDay = this.value.find((el) => el === formatDay)

      if (sameDay) {
        const filtredDate = this.value.filter((el) => el !== sameDay)
        day.el.style.cssText = `background: transparent;`

        this.$emit('input', [...filtredDate])
      } else {
        this.$emit('input', [...this.value, formatDay])
      }

      day.el.blur()
    }

    return {
      onDayClick,
      calendarRef,
      rangeDateAttr,
      display
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style.scss';
</style>
